export class StringUDF {

  public thingTypeFieldId: number;

  public time: number;

  public value: string;


  constructor(value: string) {
    this.value = value;
  }
}



// WEBPACK FOOTER //
// ./src/models/UDFs/StringUDF.ts